export const namespaces = ["common"] as const;

export type Namespace = ElementType<typeof namespaces>;
